import React from 'react';
import { graphql } from 'gatsby';
import styled from '@emotion/styled';
import Layout from 'src/layouts/default/default';
import Container from 'src/components/Container';
import Breadcrumb from 'src/components/Breadcrumb';

import Banner from 'src/components/Banner';

const Title = styled.h1({
  color: '#004098',
  fontSize: '25px',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '15px',
});

const DateText = styled.div({
  width: '100%',
  background: '#f5f5f5',
  height: '35px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20px',
  marginBottom: '20px',
});

const VideoFrame = styled.div({
  margin: '50px auto',
  display: 'block',
  width: '640px',
  height: '498px',
});

export default function Template({ data }) {
  const { bannerImage } = data;
  const videoJson = data.wordpressPage;
  const pathToRoot = [
    { text: '首页', href: '/' },
    { text: '视频中心', href: '/videos/1' },
  ];
  const pathCurrent = { text: videoJson.date };
  return (
    <Layout
      title={videoJson.title}
      keywords="无人驾驶环卫车_无人扫地车_无人清扫车_安防巡检机器人_SLAM_激光导航-高仙机器人"
    >
      <Banner
        title="视频中心"
        subtitle="Video Center"
        height="400px"
        fluid={bannerImage.childImageSharp.fluid}
      />
      <Container>
        <Breadcrumb pathToRoot={pathToRoot} current={pathCurrent} />
        <Title>{videoJson.title}</Title>
        <DateText>日期: {videoJson.date}</DateText>
        <VideoFrame dangerouslySetInnerHTML={{ __html: videoJson.content }} />
        {/* <VideoFrame
          title="t"
          frameBorder="0"
          width="640"
          height="498"
          src={videoJson.iframeURL}
          allowFullScreen
        /> */}
      </Container>
    </Layout>
  );
}

export const query = graphql`
  query($id: String!) {
    bannerImage: file(relativePath: { eq: "news/banner.jpg" }) {
      id
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    wordpressPage(id: { eq: $id }) {
      id
      title
      excerpt
      content
      date(formatString: "YYYY.MM.DD")
    }
  }
`;
